var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapBottomMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 76,
    viewBox: "0 0 375 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.5 0h375v78H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.415,
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "m-22.78 43.665 78.855-40.2L219.97 29.75l204.865-20.1 90.45 29.38L684.33 50.11v135.03H-326.86V69.695z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.415,
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M-150.34 60.675 185.18 8.88l234.245 49.475 67.255-42.52 90.45 3.095 44.84 31.695v48.96h-784.935z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.805 2.35 273.06 48.675-89.73-1l-265.395 18.14L-366 792.115l1105.065-2.79s1.715-792 6.74-786.975z",
    stroke: "#231F20",
    strokeWidth: 1.415,
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBottomMobile);
export default __webpack_public_path__ + "static/media/roadmapBottomMobile.80dbc4241e2fc737c19a932475ea573a.svg";
export { ForwardRef as ReactComponent };